import PageHead from "@/components/PageHead";
import LegalLayout from "@/components/LegalLayout";
import cookiesMd from "@/content/legal/cookies.md?raw";
import childMd from "@/content/legal/child-safety.md?raw";
import aiMd from "@/content/legal/responsible-ai.md?raw";
import mentorMd from "@/content/legal/mentor-code.md?raw";

const DOCS = {
  cookies: { md: cookiesMd, path: "/cookies", title: "Cookie Policy", desc: "How wekit.ai uses cookies and the choices you have." },
  "child-safety": { md: childMd, path: "/child-safety", title: "Child Safety & Safeguarding Policy", desc: "How WeKIT™ keeps children and young people safe." },
  "responsible-ai": { md: aiMd, path: "/responsible-ai", title: "Responsible AI Policy", desc: "How WeKIT™ Career Intelligence is designed, reviewed and constrained." },
  "mentor-code": { md: mentorMd, path: "/mentor-code", title: "Mentor Code of Conduct & Ethics", desc: "The ethical standard every WeKIT™ mentor accepts." },
} as const;

export default function PolicyPage({ doc }: { doc: keyof typeof DOCS }) {
  const d = DOCS[doc];
  return (
    <>
      <PageHead title={`${d.title} | WeKIT™`} description={d.desc} path={d.path} />
      <LegalLayout markdown={d.md} />
    </>
  );
}
